/** Query keys for the campaign targets table. */
export const campaignTargetKeys = {
  all: ["campaign-targets"],
  lists: () => [...campaignTargetKeys.all, "list"],
  list: ({ campaignId = null } = {}) => [
    ...campaignTargetKeys.lists(),
    { campaignId },
  ],
};
